import Box from "@mui/material/Box";

import CircularProgress from "@mui/material/CircularProgress";
import { green, blue } from "@mui/material/colors";
import Fab from "@mui/material/Fab";

import {ReactComponent as CheckIcon} from "../icons/Check24.svg";
import {ReactComponent as QrCodeScannerIcon} from "../icons/QrCodeScanner24.svg";
import {ReactComponent as HourglassTopIcon} from "../icons/HourglassTop24.svg";

export default function IconLoader({iconName, progress, success}) {
  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      "&:hover": {
        bgcolor: green[700],
      },
    }),
  };

  return (
    <Box sx={{ m: 1, position: "relative" }}>
      <Fab
        aria-label="save"
        color="primary"
        sx={buttonSx}
      >
        {!progress ? (iconName === "scanner" ? <QrCodeScannerIcon /> : <CheckIcon />) : <HourglassTopIcon />}
      </Fab>
      {progress && (
        <CircularProgress
          size={68}
          sx={{
            color: blue[500],
            position: "absolute",
            top: -6,
            left: -6,
            zIndex: 1,
          }}
        />
      )}
    </Box>
  );
}
